import React, { useRef, useEffect } from 'react';
import { Pencil, Check } from 'lucide-react';

interface ProfileDocumentFieldProps {
  tipoIdentificacion: string;
  numeroIdentificacion: string;
  tipoDocs: string[];
  isEditing: boolean;
  onToggleEdit: () => void;
  onChangeTipo: (val: string) => void;
  onChangeNumero: (val: string) => void;
}

export const ProfileDocumentField: React.FC<ProfileDocumentFieldProps> = ({
  tipoIdentificacion,
  numeroIdentificacion,
  tipoDocs,
  isEditing,
  onToggleEdit,
  onChangeTipo,
  onChangeNumero,
}) => {
  const numInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (isEditing) {
      numInputRef.current?.focus();
    }
  }, [isEditing]);

  return (
    <div className="space-y-1.5">
      <label className="block text-[11px] font-black text-slate-500 uppercase tracking-wider">
        Identificación
      </label>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5">
        {/* Tipo de Documento */}
        <div className="relative">
          {isEditing ? (
            <select
              value={tipoIdentificacion}
              onChange={(e) => onChangeTipo(e.target.value)}
              className="w-full px-3.5 py-2.5 bg-white border-2 border-sky-500 ring-2 ring-sky-100 rounded-xl text-xs sm:text-sm font-bold text-slate-900 shadow-xs outline-none transition-all cursor-pointer"
            >
              {tipoDocs.map((t) => (
                <option key={t} value={t}>{t}</option>
              ))}
            </select>
          ) : (
            <div
              onClick={onToggleEdit}
              className="w-full px-3.5 py-2.5 bg-slate-200/80 hover:bg-slate-200 border border-slate-300/80 rounded-xl text-xs sm:text-sm font-bold text-slate-800 truncate cursor-pointer transition-colors select-none"
            >
              {tipoIdentificacion}
            </div>
          )}
        </div>

        {/* Número de Documento */}
        <div className="relative flex items-center">
          {isEditing ? (
            <>
              <input
                ref={numInputRef}
                type="text"
                value={numeroIdentificacion}
                onChange={(e) => onChangeNumero(e.target.value)}
                placeholder="Número de documento"
                className="w-full pl-3.5 pr-10 py-2.5 bg-white border-2 border-sky-500 ring-2 ring-sky-100 rounded-xl text-xs sm:text-sm font-bold text-slate-900 shadow-xs outline-none transition-all"
              />
              <button
                type="button"
                onClick={onToggleEdit}
                title="Confirmar edición"
                className="absolute right-2 p-1.5 rounded-lg bg-emerald-50 hover:bg-emerald-100 text-emerald-600 transition-colors cursor-pointer"
              >
                <Check className="w-4 h-4 stroke-[2.5]" />
              </button>
            </>
          ) : (
            <>
              <input
                type="text"
                readOnly
                onClick={onToggleEdit}
                value={numeroIdentificacion || ''}
                placeholder="Sin número"
                className="w-full pl-3.5 pr-10 py-2.5 bg-slate-200/80 hover:bg-slate-200 border border-slate-300/80 rounded-xl text-xs sm:text-sm font-bold text-slate-800 cursor-pointer outline-none transition-colors"
              />
              <button
                type="button"
                onClick={onToggleEdit}
                title="Hacer clic para editar"
                className="absolute right-2 p-1.5 rounded-lg hover:bg-slate-300/60 text-slate-600 hover:text-sky-700 transition-colors cursor-pointer"
              >
                <Pencil className="w-4 h-4" />
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
